import { hideError } from "components/Error/store/Actions";
import * as React from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { CajitaStore, IErrorMessageProps } from "root/store/CajitaStore";
import { IErrorActionCreator } from "types/error_action_creator";

/**
 * ErrorMessage Statefull Component
 */

class ErrorMessageComponent extends React.Component<IErrorMessageProps> {
  public componentDidUpdate(): void {
    if (!this.props.hidden) setTimeout(() => this.props.hideError(), 5000); // 5 seconds
  }

  public render(): React.ReactNode {
    return (
      <div>
        <div className="error-message" hidden={this.props.hidden}>
          {this.props.message}
        </div>
      </div>
    );
  }
}

const mapStateToProps: (state: CajitaStore) => IErrorMessageProps = (
  state: CajitaStore
): IErrorMessageProps => state.error;

const mapDispatchToProps: (dispatch: Dispatch) => object = (
  dispatch: Dispatch
): object => ({
  hideError: (): IErrorActionCreator => dispatch(hideError()),
});

const ErrorMessage: React.ComponentClass = connect<
  IErrorMessageProps,
  {},
  {},
  CajitaStore
>(
  mapStateToProps,
  mapDispatchToProps
)(ErrorMessageComponent);

export { ErrorMessage };



// WEBPACK FOOTER //
// ./src/components/Error/ErrorMessageComponent.tsx